"use client";

import { useEffect } from "react";

import { useComponentLifecycle } from "@stadium/hooks/lib/use-component-lifecycle";

import { useStoreContext } from "@components/store/provider";

type PageBreadcrumbRegistrationProps = {
  breadcrumbPageType: string;
};

/**
 * Opts the current store page into Swagmagic breadcrumbs.
 * Mount on any page (including server-rendered trees) that should show crumbs.
 */
const PageBreadcrumbRegistration = ({ breadcrumbPageType }: PageBreadcrumbRegistrationProps) => {
  const { setPageState, resetPageState } = useStoreContext();

  useComponentLifecycle({ onUnmount: resetPageState });

  useEffect(() => {
    setPageState((state) => ({
      ...state,
      breadcrumbPageType,
    }));
  }, [breadcrumbPageType, setPageState]);

  return null;
};

export default PageBreadcrumbRegistration;
